import { render, staticRenderFns } from "./configuracion.vue?vue&type=template&id=cb542c8c&scoped=true&"
import script from "./configuracion.vue?vue&type=script&lang=ts&"
export * from "./configuracion.vue?vue&type=script&lang=ts&"
import style0 from "./configuracion.vue?vue&type=style&index=0&id=cb542c8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb542c8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCheckbox,VCol,VIcon,VRow,VSelect})
